import { FieldError, FieldValues, Path } from "react-hook-form";
import { Input } from "@songtradr-one/components-frontend";
import { FormFieldWrapper } from "../../../form-field-wrapper/FormFieldWrapper";
import { Props } from "./TextField.Parts";

export const TextField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>({
  errors,
  register,
  rules,
  label,
  name,
  single,
  disabled,
  defaultValue,
  type,
  placeholder,
  readOnly,
  copyable,
  customActions,
  onBlur,
}: Props<FormFields, FieldName>) => {
  const registrationProps = register(name, {
    ...rules,
    ...(type === "number" && {
      setValueAs: (v: string) => (v === "" ? undefined : parseInt(v, 10)),
    }),
  });

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    registrationProps.onBlur(event);
    if (onBlur) onBlur(event);
  };

  return (
    <FormFieldWrapper $single={single} error={errors[name] as FieldError}>
      <Input
        fullWidth
        type={type}
        label={label}
        disabled={disabled}
        readOnly={readOnly}
        copyable={copyable}
        customActions={customActions}
        placeholder={placeholder}
        hasError={Boolean(errors[name])}
        {...registrationProps}
        defaultValue={defaultValue}
        onBlur={handleBlur}
      />
    </FormFieldWrapper>
  );
};
